import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=7b562a82&scoped=true"
import script from "./CopyButton.vue?vue&type=script&lang=js"
export * from "./CopyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b562a82",
  null
  
)

export default component.exports